import React from 'react';
import { Link } from 'gatsby';
import LocalizedLink from '../localizedLink';

// Keep unresolved CMS destinations visible without inventing a homepage link.
export default function HeaderLink({ link, children, className, onClick }) {
  const url = link?.url;
  if (url) {
    const internal = link.link_type === 'Document';
    const destination =
      internal && /^https?:\/\//i.test(url)
        ? new URL(url).pathname + new URL(url).search + new URL(url).hash
        : url;
    if (destination.startsWith('/') && !destination.startsWith('//')) {
      return (
        <Link to={destination} className={className} onClick={onClick}>
          {children}
        </Link>
      );
    }
    const external = /^https?:\/\//i.test(url) || url.startsWith('//');
    return (
      <a
        href={url}
        className={className}
        onClick={onClick}
        target={link.target || (external ? '_blank' : undefined)}
        rel={external ? 'nofollow noopener noreferrer' : undefined}
      >
        {children}
      </a>
    );
  }
  if (link?.uid) {
    return (
      <LocalizedLink
        to={String(link.uid).replace(/^\/+/, '')}
        className={className}
        onClick={onClick}
      >
        {children}
      </LocalizedLink>
    );
  }
  return (
    <span className={className} aria-disabled="true">
      {children}
    </span>
  );
}
